/** Custom config file for Video blot of quill-editor. */
import ReactQuill from 'react-quill';

// 1. Get the existing "block/embed" blot
const BlockEmbed = ReactQuill.Quill.import('blots/block/embed');
// const Embed = ReactQuill.Quill.import('blots/embed'); // <--- Change this line

// 2. Create your custom video blot, extending the base one
export default class VideoBlot extends BlockEmbed {
  static create(value: string) {
    const node = super.create() as HTMLVideoElement; // Cast node to HTMLVideoElement

    // Set the attributes you want on the <video> tag
    node.setAttribute('src', value);
    node.setAttribute('autostart', 'false');
    node.setAttribute('controls', 'true');
    node.setAttribute('width', '100%'); // Optional: set a default width
    // node.setAttribute('style', 'padding: 16px;');
    node.setAttribute('preload', 'metadata');
    node.setAttribute('contenteditable', 'false'); // Recommended for blotFormatter
    node.setAttribute('style', 'max-height: 700px;');

    return node;
  }

  // This will be used to get the value back from the blot
  static value(node: HTMLVideoElement) {
    return node.getAttribute('src');
  }
}

// 3. Give your blot a name and the HTML tag it should create
VideoBlot.blotName = 'video';
VideoBlot.tagName = 'video';

// 4. Register your custom blot with Quill, overriding the default video blot
ReactQuill.Quill.register(VideoBlot);
